(function () {
  'use strict';

  function initialize(root) {
    if (root.dataset.e500v2Ready) return;
    root.dataset.e500v2Ready = 'true';

    var dataNode = root.querySelector('[data-e500v2-data]');
    var data = JSON.parse(dataNode.textContent);
    var form = root.querySelector('[data-e500v2-form]');
    var qty = form.querySelector('[name="quantity"]');
    var submit = root.querySelector('[data-add-to-cart]');
    var status = root.querySelector('[data-e500v2-status]');
    var sticky = root.querySelector('[data-e500v2-sticky]');
    var stickyButton = sticky.querySelector('button');

    // Offset the in-page detail nav only by a real, currently visible sticky Shopify header.
    var navFrame = 0;
    function positionDetailNav() {
      navFrame = 0;
      var header = document.querySelector('.section-header.shopify-section-header-sticky');
      var bottom = header ? header.getBoundingClientRect().bottom : 0;
      root.style.setProperty('--e500v2-nav-offset', Math.max(0, Math.min(window.innerHeight, bottom)) + 'px');
    }
    function queueDetailNav() { if (!navFrame) navFrame = window.requestAnimationFrame(positionDetailNav); }
    positionDetailNav();
    window.addEventListener('scroll', queueDetailNav, { passive: true });
    window.addEventListener('resize', queueDetailNav, { passive: true });

    var selected = data.variants.filter(function (v) { return String(v.id) === String(data.selected); })[0] || data.variants[0];
    var pending = false;
    var currency = data.currency || 'USD';
    var formatter = new Intl.NumberFormat(data.locale || 'en-US', { style: 'currency', currency: currency });
    function money(cents) { return formatter.format(cents / 100); }

    function setText(selector, value) {
      root.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
    }
    function show(selector, visible) {
      root.querySelectorAll(selector).forEach(function (el) { el.hidden = !visible; });
    }
    function setImage(url, alt) {
      var main = root.querySelector('[data-e500v2-image]');
      if (!url || !main) return;
      main.src = url;
      main.alt = alt || data.title;
      main.removeAttribute('srcset');
      root.querySelectorAll('[data-e500v2-gallery-img]').forEach(function (el) {
        el.src = url;
        el.alt = alt || data.title;
      });
    }

    function refreshFinancing(amount) {
      root.querySelectorAll('.affirm-as-low-as').forEach(function (el) { el.dataset.amount = String(amount); });
      if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) window.affirm.ui.refresh();
      // The existing theme Klarna placement reads the same purchase amount.
      root.querySelectorAll('klarna-placement').forEach(function (el) { el.setAttribute('data-purchase-amount', String(amount)); });
    }

    function updateBox(v) {
      var key = v.box || 'basic';
      root.querySelectorAll('[data-e500v2-box]').forEach(function (container) {
        container.hidden = container.dataset.e500v2Box !== key;
      });
    }

    function updateVariant(v, replaceUrl) {
      if (!v) return;
      selected = v;
      var finalPrice = v.price - Math.round(v.price * data.extraDiscount / 100);
      var compare = v.compare_at_price || 0;
      var discounted = compare > v.price;

      root.querySelectorAll('[data-e500v2-variant]').forEach(function (card) {
        var active = String(card.dataset.e500v2Variant) === String(v.id);
        card.classList.toggle('is-selected', active);
        var input = card.querySelector('input');
        if (input) input.checked = active;
      });

      setText('[data-e500v2-price]', money(v.price));
      setText('[data-e500v2-compare]', money(compare));
      setText('[data-e500v2-save]', money(Math.max(0, compare - v.price)) + ' OFF');
      setText('[data-e500v2-final]', money(finalPrice));
      setText('[data-e500v2-extra-save]', money(v.price - finalPrice));
      setText('[data-e500v2-name]', v.title === 'Default Title' ? data.title : v.title);
      show('[data-e500v2-compare], [data-e500v2-save]', discounted);
      setText('[data-e500v2-breakdown-original]', money(discounted ? compare : v.price));

      var rule = v.quantity_rule || { min: 1, increment: 1 };
      qty.min = String(rule.min || 1);
      qty.step = String(rule.increment || 1);
      if (rule.max) qty.max = String(rule.max); else qty.removeAttribute('max');
      qty.value = String(rule.min || 1);

      submit.disabled = !v.available;
      stickyButton.disabled = !v.available;
      submit.textContent = v.available ? 'Add to cart' : 'Sold out';
      stickyButton.textContent = v.available ? 'Add To Cart' : 'Sold out';

      setImage(v.image, v.title);
      status.textContent = '';
      refreshFinancing(finalPrice);
      updateBox(v);

      if (replaceUrl && !data.preview) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
      root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
      // the ported official detail area listens for this to sync "what's in the box"
      root.dispatchEvent(new CustomEvent('e500v2:variant', { bubbles: true, detail: { box: v.box || 'basic', title: v.title } }));
    }

    root.querySelectorAll('[data-e500v2-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        setImage(button.dataset.e500v2Thumb, button.querySelector('img').alt);
        root.querySelectorAll('[data-e500v2-thumb]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
      });
    });

    root.querySelectorAll('[data-e500v2-variant] input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateVariant(data.variants.filter(function (v) { return String(v.id) === radio.value; })[0], true);
      });
    });

    root.querySelectorAll('[data-e500v2-qty-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = Number(qty.step) || 1;
        var min = Number(qty.min) || 1;
        var max = qty.max ? Number(qty.max) : Infinity;
        qty.value = Math.min(max, Math.max(min, (Number(qty.value) || min) + Number(button.dataset.e500v2QtyStep) * step));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // One variant ID and one quantity are posted to this store's own cart endpoint.
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (pending || !selected.available || !form.reportValidity()) return;
      if (data.preview) {
        status.textContent = 'Preview only — the live page submits to your own Shopify product, price and inventory.';
        return;
      }
      pending = true;
      submit.disabled = stickyButton.disabled = true;
      submit.textContent = 'Adding…';
      status.textContent = '';
      try {
        var response = await fetch(data.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: selected.id, quantity: Number(qty.value) }] })
        });
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
        status.appendChild(document.createTextNode('Added to your cart. '));
        var link = document.createElement('a');
        link.href = data.cartUrl;
        link.textContent = 'View cart →';
        status.appendChild(link);
        window.location.assign(data.cartUrl);
      } catch (error) {
        status.textContent = error.message || 'Unable to add this item. Please try again.';
      } finally {
        pending = false;
        submit.disabled = stickyButton.disabled = !selected.available;
        submit.textContent = selected.available ? 'Add to cart' : 'Sold out';
      }
    });

    stickyButton.addEventListener('click', function () { form.requestSubmit(submit); });

    // Tabs used by the "4 ways to recharge" and "How people use it" modules.
    root.querySelectorAll('[data-e500v2-tab-group]').forEach(function (group) {
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[role="tab"]'));
      var panels = group.querySelectorAll('[role="tabpanel"]');
      function activate(tab) {
        tabs.forEach(function (t) {
          var active = t === tab;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
        });
        panels.forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { activate(tab); });
        tab.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) { event.preventDefault(); activate(next); next.focus(); }
        });
      });
      if (tabs[0]) activate(tabs[0]);
    });

    // Configurator cards and buttons select the matching purchase variant.
    root.querySelectorAll('[data-e500v2-config]').forEach(function (button) {
      button.addEventListener('click', function () {
        var key = button.dataset.e500v2Config;
        var match = data.variants.filter(function (v) { return (v.box || 'basic') === key; })[0];
        if (match) updateVariant(match, true);
        form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });

    var dialog = root.querySelector('[data-e500v2-dialog]');
    var zoom = root.querySelector('[data-e500v2-zoom]');
    if (dialog && zoom) {
      zoom.addEventListener('click', function () {
        var main = root.querySelector('[data-e500v2-image]');
        dialog.querySelector('img').src = main.src;
        dialog.querySelector('img').alt = main.alt;
        dialog.showModal();
      });
      dialog.querySelector('button').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.inert = !visible;
      }, { threshold: 0 }).observe(submit);
    }

    // Pause offscreen video, respect reduced motion, load only the active breakpoint.
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var mobile = window.matchMedia('(max-width:749px)');
    root.querySelectorAll('video[data-e500v2-video]').forEach(function (video) {
      var active = video.classList.contains('e500v2-kv__mobile') === mobile.matches;
      if (!active) return;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            var source = video.querySelector('source');
            if (source && source.dataset.src && !source.getAttribute('src')) {
              source.src = source.dataset.src;
              video.load();
            }
            if (!reduced) video.play().catch(function () {});
          } else {
            video.pause();
          }
        }, { rootMargin: '150px' }).observe(video);
      }
    });

    updateVariant(selected, false);
  }

  function boot(scope) { scope.querySelectorAll('[data-e500v2-root]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
